const messages: Record<string, string> = {};

export default messages;
